import RecentInspections from './RecentInspections';
import { useInspectionCouncil } from '../../hooks/useInspectionCouncil';
import InspectionTab from './InspectionTab';

export default function InspectionTabContainer({ slots, concealModelIdentities }) {
  const props = useInspectionCouncil({ slots, concealModelIdentities });
  return <><InspectionTab {...props} /><RecentInspections variant="full" finishedRun={props.finalVerdict || props.error} /></>;
}
